import { useRouter } from "next/router";
import { ArrowLeft } from "lucide-react";
import { JhText } from "designPackages/textPackage";

const SubHeader = ({ title = "", isBack = false, onBackClick }) => {
  const router = useRouter();
  const handleBack = () => {
    if (onBackClick) {
      onBackClick();
    } else router.back();
  };
  return (
    <div className="sticky tw-root top-0 z-50 flex items-center py-5 px-6 border-t bg-background">
      {isBack ? (
        <ArrowLeft
          className="w-5 h-5 mr-4 cursor-pointer"
          onClick={handleBack}
        />
      ) : null}
      <JhText variant="emphasis2" color="foreground">
        {title}
      </JhText>
    </div>
  );
};
export default SubHeader;
